import { enqueueSnackbar } from 'notistack';
import { getAccessToken } from '../../maslConfig';
import { fetchBaseQuery, BaseQueryApi } from '@reduxjs/toolkit/query/react';
import baseUrl from '../json/baseURL.json';

let sessionExpiredNotified = false;
// Custom base query with authentication handling
export const baseQueryWithAuth = async (args: any, api: BaseQueryApi, extraOptions: {}) => {
  const accessToken = await getAccessToken();
  if (!accessToken) {
    if (!sessionExpiredNotified) {
      enqueueSnackbar('Session expired, Please login again', {
        variant: 'error',
      });
      sessionExpiredNotified = true;
      return { error: { status: 401, data: { message: 'Session expired' } } };
    }
  }

  const baseQueryFn = fetchBaseQuery({
    baseUrl: baseUrl.baseUrl[0].url,
    prepareHeaders: (headers) => {
      headers.set('Authorization', `Bearer ${accessToken}`);
      return headers;
    },
  });

  const result = await baseQueryFn(args, api, extraOptions);
  return result;
};
